export default __webpack_public_path__ + "static/media/plantImage.7f1a6f3e.svg";